import React from "react";
import styled from "styled-components";

const Input = styled.input`
    height: 0;
    width: 0;
    opacity: 0;
    padding: 0;
    border: none;
    outline: 0;
    position: fixed;
    top: -100px;
`;

export const HoneyPotInput: React.FC<any> = ({ children }) => {
    return (
        <>
            <Input data-test-class="default-input" readOnly/>
            {children}
            <Input data-test-class="default-input" readOnly/>
        </>
    )
}